import { defineMessages } from 'react-intl';

export default defineMessages({
  bestOption: {
    id: 'pricing.upgrades.bestOption',
    defaultMessage: 'Best for you',
  },
});
